import { gsap, ScrollTrigger } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// Sticky showcase stack: each [data-sticky] panel scales and fades out as the
// next panel scrolls up to cover it.
//
// Deliberately NO blur here: animating filter on full-viewport panels (which
// carry gradients, glows and big box-shadows) forces constant repaints and
// shimmers badly while scrubbing. Scale + opacity composite on the GPU.
export function initStickyStack(): void {
  if (prefersReducedMotion()) return;

  const panels = Array.from(document.querySelectorAll<HTMLElement>('[data-sticky]'));
  panels.forEach((panel, i) => {
    if (i === panels.length - 1) return;
    gsap.to(panel, {
      scale: 0.94,
      opacity: 0.2,
      ease: 'none',
      force3D: true,
      scrollTrigger: {
        trigger: panels[i + 1],
        start: 'top bottom',
        end: 'top top',
        scrub: true,
      },
    });
  });

  window.setTimeout(() => ScrollTrigger.refresh(), 500);
}
